import React, { useEffect, useState } from "react";
import TopNav from "../../TopNav";
import { Button, Div, Text } from "../../StyledComponents";
import { NumCount, SubTitle, TextArea } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";
import {
  GetFeedback,
  RefreshFeedback,
} from "../../../StateManagement/Reducers/SettingState";
import { toast } from "react-toastify";
import Error from "../../StyledComponents/Toastify/Error";
import { RiArrowLeftLine } from "react-icons/ri";

const FeedBack = () => {
  //-----------------------------State and  Variables Start----------------------------- //

  const dispatch = useDispatch();

  const Refresh = useSelector((state) => state.Setting.RefreshFeedback);
  const [comment, setComment] = useState("");
  const [commentErr, setCommentErr] = useState(false);
  const [disable, setdisable] = useState(false);
  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");
  //-----------------------------State and  Variables End----------------------------- //
  //-----------------------------Function Start--------------------------------------- //
  const handleComment = (e) => {
    setComment(e.target.value);
    setCommentErr(false);
  };

  const handleKeyPress = (e) => {
    if (e.key == " ") {
      if (comment.endsWith(" ") || comment.length == 0) {
        e.preventDefault();
      }
    }
  };
  const handleSubmit = () => {
    if (comment.length >= 20) {
      setdisable(true);
      dispatch(GetFeedback({ pid: Pat_ID, feedback: comment }));
    } else {
      setCommentErr(true);
    }
  };
  //-----------------------------Function End----------------------------- //
  //-----------------------------useEffect Start--------------------------------------- //
  useEffect(() => {
    if (comment.length >= 500) {
      toast(<Error msg="Maximum character limit (500) reached!" />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  }, [comment]);
  useEffect(() => {
    if (Refresh === 1) {
      setdisable(false);
      setComment("");
      dispatch(RefreshFeedback(""));
    }
  }, [Refresh]);
  //-----------------------------useEffect End----------------------------- //

  return (
    <>
      <TopNav title="Settings" />
      <Div
        margin="5px 10px"
        backColor="#FFFFFF"
        minHeight="500px"
        borderRadius="12px"
        padding="24px"
      >
        <Div display="flex" alignItems="center" marginBottom="20px">
          <RiArrowLeftLine
            size="22"
            style={{ cursor: "pointer", marginRight: "8px" }}
            onClick={() => window.history.back()}
          />
          <Div fontSize="18px" fontWeight="600">
            FeedBack
          </Div>
        </Div>
        <SubTitle>Comment your Feedback</SubTitle>

        <TextArea
          border={
            commentErr
              ? "1px solid #F24822"
              : "1px solid rgba(46, 46, 46, 0.25)"
          }
          maxLength={500}
          placeholder="Write your comments here"
          onChange={handleComment}
          onKeyPress={handleKeyPress}
          value={comment}
        ></TextArea>

        {commentErr && (
          <Text
            textAlign="left"
            color="#F24822"
            fontSize="10px"
            fontWeight="500"
            mb="0px"
            mt="0px"
          >
            Feedback should be Minimum 20 characters
          </Text>
        )}
        {/* <NumCount>{comment.length}/500</NumCount> */}
        <Button
          background="#2C7BE5"
          hoverBackColor="#005FB2"
          className="save_active"
          display="flex"
          padding="9px 25px"
          alignItem="center"
          borderRadius="4px"
          marginTop="23px"
          onClick={handleSubmit}
          disabled={disable}
        >
          Submit Feedback
        </Button>
      </Div>
    </>
  );
};

export default FeedBack;
